import {React, useEffect, useState, useRef} from "react";
import './style.scss';
import { image } from "../../../Assets";
import Count from "../../../Component/Count/Count";
import BookCall from "../../../Component/BookCall/BookCall";

const CaseStudies = () =>{

    const [openModal, setOpenModal] = useState(false);
      const modalRef = useRef(null);
        
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (openModal && modalRef.current && !modalRef.current.contains(event.target)) {
            setOpenModal(false);
          }
        };
    
        const handleEsc = (event) => {
          if (event.key === "Escape") setOpenModal(false);
        };
    
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleEsc);
    
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
          document.removeEventListener("keydown", handleEsc);
        };
      }, [ openModal]);

    const caseStudies = [
        {
            id: 1,
            title: "Johns Hopkins Student Center",
            description:
            "Fractile provides customized rich rendering solutions in both 2D and 3D environments, utilizing multiple mediums to enhance user experience and decision-making capabilities.",
            image: image.caseStudies1,
            link: "/case-study/john-hopkins-case",
        },
        {
            id: 2,
            title: "NIH Surgery, Radiology & Lab Medicine (SRLM)",
            description:
            "Fractile provides customized rich rendering solutions in both 2D and 3D environments, utilizing multiple mediums to enhance user experience and decision-making capabilities.",
            image: image.caseStudies2,
            link: "/case-study/nih-surgery-case",
        },
        {
            id: 3,
            title: "Inova Alexandria Hospital at Landmark",
            description:
            "The proposed Inova Alexandria Hospital at Landmark aims to provide comprehensive, patient-centered programs and services, featuring an expanded emergency room, private patient rooms.",
            image: image.caseStudies3,
            link: "/case-study/Inova-alexandria-case",
        },
        {
            id: 4,
            title: "Montgomery College Library",
            description:
            "The Office of Facilities of Montgomery College has initiated a project to transform the Macklin Tower library on the Rockville Campus into a dynamic center for social and academic engagement within the MC community, for which Hord, Coplan, Macht (HCM) architects have been commissioned to design the renovation.",
            image: image.caseStudies4,
            link: "/case-study/montgomery-college-case",
        },
        {
            id: 5,
            title: "O’Hare International Airport Terminal 3 Improvements",
            description:
            "The ElevateT3 modernization project, a key part of the O’Hare ’21 initiative aimed at transforming Chicago O’Hare International Airport, involves a three-story expansion within Phase 1 of the Terminal 3 Improvements.  ",
            image: image.caseStudies5,
            link: "/case-study/ohare-international-airport-case",
        },
        {
            id: 6,
            title: "IAD 550 C",
            description:
            "The proposed development on a 150-acre site in Mineral, Virginia, involves the construction of a data center campus spanning 150 acres, featuring eight data hall facilities exceeding 1.6 million square feet and 390 megawatts, alongside a central administration building, two onsite power distribution substations, and a water treatment facility, necessitating massive site work exercise including tree clearing, paving, utilities, stormwater management infrastructure, and landscaping.",
            image: image.caseStudies6,
            link: "/case-study/iad-550-c-case",
        },
        ];
      
    return(
        <>           
            <section className="casestudy-main-sec">
                <div className="container">
                    <div className="row">                        
                        <div className="col-lg-6 col-sm-12 col-12 tw-text-left">   
                            <h2><b>Case Studies</b></h2>                         
                            <p>
                            As the industry grapples with a scarcity of skilled labor, Fractile Studio understands the challenges of navigating the digital landscape. We stand as experienced and accountable partners, ready to tailor our resources to meet your digital processing needs.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="casestudy-section d2">
                <div className="container">
                    {caseStudies.map((item, index) => {
                    const isEven = index % 2 === 0;

                    return (
                        <div
                        key={item.id}
                        className="tw-pt-5 tw-pb-5 tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-10 tw-items-center"
                        >
                        {isEven ? (
                            <>
                            <div className="lg:tw-col-span-6">
                                <img
                                src={item.image}
                                alt={item.title}
                                className="tw-w-full lg:tw-w-[100%] lg:tw-ml-auto"
                                />
                            </div>

                            <div className="lg:tw-col-span-6">
                                <h3 className="tw-text-2xl sm:tw-text-3xl tw-font-semibold !tw-font-semibold tw-text-[#157438] tw-mb-4">
                                {item.title}
                                </h3>

                                <p className="tw-text-black tw-mb-6">{item.description}</p>

                                <a
                                href={item.link}
                                className="btn-2 tw-inline-block tw-px-6 tw-py-3 tw-border tw-border-[#157438] tw-bg-[#157438] tw-text-white tw-transition-all"
                                >
                                Know More
                                </a>
                            </div>
                            </>
                        ) : (
                            <>
                            <div className="lg:tw-col-span-6">
                                <h3 className="tw-text-2xl sm:tw-text-3xl tw-font-semibold !tw-font-semibold tw-text-[#157438] tw-mb-4">
                                {item.title}
                                </h3>

                                <p className="tw-text-black tw-mb-6">{item.description}</p>

                                <a
                                href={item.link}
                                className="btn-2 tw-inline-block tw-px-6 tw-py-3 tw-border tw-border-[#157438] tw-bg-[#157438] tw-text-white tw-transition-all"
                                >
                                Know More
                                </a>
                            </div>

                            <div className="lg:tw-col-span-6">
                                <img
                                src={item.image}
                                alt={item.title}
                                className="tw-w-full lg:tw-w-[100%] lg:tw-ml-auto"
                                />
                            </div>
                            </>
                        )}
                        </div>
                    );
                    })}
                </div>
            </section>

            <Count/>

            {/* Book a call section */}           
            <section>
                <div className="container tw-pt-10 md:tw-pt-15">
                    <div
                    className=" row tw-bg-[#157438] tw-text-white tw-p-[30px] md:tw-p-[60px] tw-my-[50px] tw-mx-auto tw-rounded-[30px] tw-flex tw-flex-wrap"
                    >
                    {/* Left Content */}
                    <div className="col-sm-9 col-12">
                        <h3 className="tw-text-[35px] tw-font-semibold tw-leading-tight tw-mb-4 max-md:tw-text-[24px]">
                            Lets Get Working
                        </h3>
                        <h5 className="tw-mb-2">At Fractile, you'll work on impactful projects, learn from seasoned leaders, and grow your technical craft. If you're committed to excellence, we're committed to you.</h5>
                    </div>

                    {/* Right Button */}
                    <div className="col-sm-3 col-12 tw-flex tw-items-end max-sm:tw-mt-6 md:tw-pt-0 tw-pt-5">
                        <button className="btn-2-white  tw-w-[80%] md-tw-w-[350px]"  onClick={() => setOpenModal(true)}>
                           Discuss Your Project
                        </button>
                    </div>
                    </div>
                </div>
            </section>

            {/* Book a call model */}
            <BookCall isOpen={openModal} onClose={() => setOpenModal(false)}/>   
        </>
    )
}

export default CaseStudies;
